import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import Layout from '../layout';
import BaseSwiper from '@src/components/swiper/base-swiper';

// import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const PedigreeChartModal = ({ store, onClose, locales }) => {
  store.use();

  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <Layout className={cx(styles.pedigreeChartModalRoot)} isOpen={store.isOpen} onClose={store.onClickClose}>
      <div className={styles.content}>
        <div className={styles.modalContent}>
          <h3 className={styles.title}>{locales.modelTree}</h3>
          <img className={styles.pedigreeChart} src={store.chart} alt="" />
        </div>
        <div className={styles.tabBar}>
          <BaseSwiper store={store.swiper}>
            {store.tabList.map((item, idx) => (
              <div
                onClick={() => store.onTabChange(item, idx)}
                key={item.src + idx}
                className={cx(styles.tabItem, idx === store.currentIndex && styles.tabActive, store.tabList.length === 1 && styles.tabOnlyOne)}
              >
                <img src={item.src} alt="" />
              </div>
            ))}
          </BaseSwiper>
        </div>
      </div>
    </Layout>
  );
};

export default wrapStore(PedigreeChartModal, Store);
